import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type {
  ITechWorksFilter,
  ITechWorksPanelFilter,
  ITechWorksPeriod,
} from "../shared/interfaces/tech-works-filter";
import { createEmptyTechWorksPanelFilter } from "../shared/utils/tech-works-filter";

import { TECH_WORKS_MODULE_NAME } from "./constants";

interface ITechWorksState extends ITechWorksFilter {
  farmId: string | null;
  seasonId: string | null;
}

const initialState: ITechWorksState = {
  farmId: null,
  seasonId: null,
  panel: createEmptyTechWorksPanelFilter(),
  period: null,
  withoutTechOperation: false,
};

const techWorksSlice = createSlice({
  name: TECH_WORKS_MODULE_NAME,
  initialState,
  reducers: {
    initializeTechWorksFilter(
      state,
      {
        payload,
      }: PayloadAction<{
        farmId: string;
        seasonId: string;
        period: ITechWorksPeriod;
      }>
    ) {
      if (state.farmId !== payload.farmId) {
        state.panel = createEmptyTechWorksPanelFilter();
      }
      if (state.seasonId !== payload.seasonId || !state.period) {
        state.period = payload.period;
      }
      state.farmId = payload.farmId;
      state.seasonId = payload.seasonId;
    },
    applyTechWorksPanelFilter(state, { payload }: PayloadAction<ITechWorksPanelFilter>) {
      state.panel = payload;
    },
    resetTechWorksPanelFilter(state) {
      state.panel = createEmptyTechWorksPanelFilter();
    },
    setTechWorksPeriod(state, { payload }: PayloadAction<ITechWorksPeriod>) {
      state.period = payload;
    },
    toggleTechWorksWithoutOperation(state) {
      state.withoutTechOperation = !state.withoutTechOperation;
    },
  },
});

export const techWorksReducer = techWorksSlice.reducer;
export const {
  initializeTechWorksFilter,
  applyTechWorksPanelFilter,
  resetTechWorksPanelFilter,
  setTechWorksPeriod,
  toggleTechWorksWithoutOperation,
} = techWorksSlice.actions;
